<div class="sidenav">
  <div [ngClass]="showLabels ? 'width-expanded' : 'width-collapsed'" id="rootmenu">
    <div class="sidenav-header">
      <i
        class="fa cursor-pointer toggle-icon"
        [ngClass]="showLabels ? 'fa-angle-left' : 'fa-angle-right'"
        (click)="toggleLabels()"
      ></i>
    </div>
    <mat-nav-list class="first">
      <a
      *ngFor="let item of menu"
      mat-list-item
      [routerLink]="item.route"
      (click)="selectRoot(item)"
      [class.disabled]="item.disabled"
      [class.active]="item == activeItem"
      >
      <fa-icon *ngIf="item.icon" [icon]="item.icon" [title]="item.label" matListItemIcon>
      </fa-icon>
      <span matListItemTitle class="label" *ngIf="showLabels">{{
          item.label
        }}</span>
      </a>
    </mat-nav-list>
    <div class="sidenav-footer">
      <a href="https://www.{{impressum[domain]}}/impressum/" target="_blank">
        <img
          *ngIf="showLabels"
          alt="smart media world"
          class="{{domain}}-logo"
          src="{{environment.CDN_URL}}/logo/{{domain}}-logo.png"
        />
        <img
          *ngIf="!showLabels"
          alt="smart media world"
          class="{{domain}}-logo-small"
          src="{{environment.CDN_URL}}/logo/{{domain}}-logo-small.png"
        />
      </a>
    </div>
  </div>
  <div *ngIf="activeItem?.children?.length && showSubmenu" id="submenu">
    <div class="submenu-container">
      <div class="sidenav-header px-3 pb-0">
        <fa-icon
          [icon]="faXmark"
          (click)="closeSubMenu()"
          class="cursor-pointer float-end close-icon"
        ></fa-icon>
        <div class="headline">
          <div>
            {{ activeItem?.headline ?? activeItem?.label }}
          </div>
          <div class="py-2 border-bottom"></div>
        </div>
      </div>
      <mat-nav-list class="second">
        <ng-container *ngFor="let item of activeItem?.children">

          <!-- Item MIT Untermenü (dritte Ebene) -->
          <a *ngIf="item.children?.length"
            mat-list-item
            class="py-1"
            [routerLink]="item.disabled ? null : item.route"
            [class.disabled]="item.disabled"
            [class.active]="item === activeSubItem && !activeSubSubItem"
            (click)="!item.disabled && selectSubItem(item)"
          >
            <span matListItemTitle class="label">{{ item.label }}</span>
          </a>
          <ng-container *ngIf="item.children?.length">
            <a *ngFor="let child of item.children"
              mat-list-item
              class="py-1"
              [routerLink]="child.disabled ? null : child.route"
              (click)="!child.disabled && selectSubSubItem(child)"
              [class.disabled]="child.disabled"
              [class.active]="child === activeSubSubItem"
            >
              <span matListItemTitle class="label child-label">{{ child.label }}</span>
            </a>
          </ng-container>

          <!-- Einfacher Item OHNE Untermenü -->
          <a *ngIf="!item.children?.length"
            mat-list-item
            class="py-1"
            [class.mt-5]="item.route != null && item.route.toLowerCase().includes('faq')"
            [routerLink]="item.disabled ? null : item.route"
            (click)="!item.disabled && selectSubItem(item)"
            [class.disabled]="item.disabled"
            [class.active]="item === activeSubItem"
          >
            <span matListItemTitle class="label">{{ item.label }}</span>
          </a>

        </ng-container>
      </mat-nav-list>
    </div>
    <div class="ps-2 version small text-version">
      v{{version}} {{buildDate}}
    </div>
  </div>
</div>
